import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=60505490&"
import script from "./UserGuide.vue?vue&type=script&lang=js&"
export * from "./UserGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports